let colors = {
  black: "#111E26",
  grey: "#4E5159",
  orange: "#F07522",
  white: "#FFFFFF",
  blue: "#2FA9DC",
  bordo: "#590c32",
  bordoLight: "#B96894",
  whiteGrey: "#F4F6F7",
  blueLight: "#548BBD",
  blueLink: "#4A94EC",
  greyTransparent: "#CDCECF",
  greyMinor: "#666666",
  greyDark: "#838D95",
  accentUltraLight: "#EEF5FD",
  // accentLight: "#2fa9dc",
  accentLight: "#7aace8",
  accentDefault: "#4A94EC",
  accentSub: "#ebe6d6",
  accentDark: "#8b6643",
  greenLight: "#a0b89d",
  green: "#00C908",
  greenDark: "#50B57B",
  warning: "#D88D00",
  error: "#EB5757",

  backgroundColor: 'linear-gradient(242.97deg, #590C32 0%, #9D1D5A 100%)'
};

if(process.env.REACT_APP_PROJECT === 'abt'){
  colors.backgroundColor = 'linear-gradient(180deg, #580E7B 0%, #300047 100%);';
  colors.bordo = '#B60078';
}

else if (process.env.REACT_APP_PROJECT === 'abf'){
  colors.backgroundColor = '#3B4D42'; // done
  colors.white = "#f7f4ef";
  colors.bordo = '#3B4D42'; // done
  colors.accentUltraLight = "#ECEBE6"; // done
  colors.accentLight = "#A6B18E"; //done
  colors.accentSub = "#ebe6d6";
  colors.accentDefault = "#3B4D42"; // done
}

else if (process.env.REACT_APP_PROJECT === 'bcf'){
  colors.backgroundColor = '#111E26';
  colors.white = "#f7f4ef";
  colors.bordo = '#111E26';
  colors.accentUltraLight = "#f4efe6";
  colors.accentLight = "#c4ac80";
  colors.accentSub = "#ebe6d6";
  colors.accentDefault = "#aa8453";
}

export const black = colors.black;
export const grey = colors.grey;
export const orange = colors.orange;
export const white = colors.white;
export const blue = colors.blue;
export const backgroundColor = colors.backgroundColor;
export const bordo = colors.bordo;
export const bordoLight = colors.bordoLight;
export const whiteGrey = colors.whiteGrey;
export const blueLight = colors.blueLight;
export const blueLink = colors.blueLink;
export const greyTransparent = colors.greyTransparent;
export const greyMinor = colors.greyMinor;
export const accentUltraLight= colors.accentUltraLight;
export const accentLight = colors.accentLight;
export const accentSub = colors.accentSub;
export const accentDefault = colors.accentDefault;
export const accentDark = colors.accentDark;
export const greyDark = colors.greyDark;
export const green = colors.green;
export const greenDark = colors.greenDark;
export const warning = colors.warning;
export const error = colors.error;

